// Holder prisvisningen i købsområdet og den faste købslinje i takt med den pakke,
// der er valgt i Kaching Bundles (antal, samlet pris og stykpris).
(function () {
  const parseMoney = (text) => {
    if (!text) return null;
    const value = parseFloat(text.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(value) ? value : null;
  };

  const formatAmount = (value) =>
    value.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formatMoney = (value) => formatAmount(value) + ' kr';

  // Udskifter kun beløbet, så temaets valutaformat (kr/DKK) bevares.
  const replaceAmount = (element, value) => {
    const text = element.textContent;
    element.textContent = /\d[\d.]*,\d{2}/.test(text)
      ? text.replace(/\d[\d.]*,\d{2}/, formatAmount(value))
      : formatMoney(value);
  };

  function readSelectedDeal() {
    const input = document.querySelector('kaching-bundles-block .kaching-bundles__bar input:checked');
    if (!input) return null;
    const bar = input.closest('.kaching-bundles__bar');
    const priceText = bar.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
    const fullText = bar.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim();
    const price = parseMoney(priceText);
    if (price === null) return null;

    const quantityInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    const quantity = Math.max(parseInt(quantityInput?.value, 10) || 1, 1);

    return { price, full: parseMoney(fullText), quantity };
  }

  function updateMainPrice(deal) {
    document.querySelectorAll('[id^="price-"][data-bundle-price]').forEach((container) => {
      // Temaets pris-snippet viser den aktuelle pris i .price__regular og førprisen i .price__sale.
      const current = container.querySelector('.price__regular span.price-item--regular');
      const compare = container.querySelector('.price__sale s.price-item--regular');
      if (current) replaceAmount(current, deal.price);
      if (compare && deal.full) replaceAmount(compare, deal.full);

      const saving = container.querySelector('[data-save-price]');
      if (saving && deal.full && deal.full > deal.price) {
        const percent = Math.round(((deal.full - deal.price) / deal.full) * 100);
        saving.textContent = saving.textContent.replace(/\d+\s*%/, percent + '%');
      }
    });

    document.querySelectorAll('[data-bundle-summary]').forEach((summary) => {
      if (deal.quantity > 1) {
        summary.textContent = `${deal.quantity} stk. · ${formatMoney(deal.price)} i alt · ${formatMoney(
          deal.price / deal.quantity
        )} pr. stk.`;
        summary.hidden = false;
      } else {
        summary.textContent = '';
        summary.hidden = true;
      }
    });
  }

  function updateStickyBar(deal) {
    const sticky = document.getElementById('StickyAddToCart');
    if (!sticky) return;
    const current = sticky.querySelector('.current-price');
    const old = sticky.querySelector('.old-price');
    const quantity = sticky.querySelector('[data-sticky-quantity]');
    if (current) replaceAmount(current, deal.price);
    if (old && deal.full) replaceAmount(old, deal.full);
    if (quantity) {
      quantity.textContent = deal.quantity > 1 ? `${deal.quantity} stk. · ` : '';
    }
  }

  function sync() {
    const deal = readSelectedDeal();
    if (!deal) return;
    updateMainPrice(deal);
    updateStickyBar(deal);
  }

  let scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    // Kaching opdaterer antalsfeltet asynkront efter valget.
    setTimeout(() => {
      scheduled = false;
      sync();
    }, 50);
  }

  function init() {
    document.addEventListener('change', (event) => {
      if (event.target.closest('kaching-bundles-block') || event.target.name === 'quantity') scheduleSync();
    });

    const observeBlock = () => {
      const block = document.querySelector('kaching-bundles-block');
      if (!block) return false;
      new MutationObserver(scheduleSync).observe(block, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['checked', 'class'],
      });
      scheduleSync();
      return true;
    };

    if (!observeBlock()) {
      // Appblokken kan blive tegnet efter DOMContentLoaded.
      const waitForBlock = new MutationObserver(() => {
        if (observeBlock()) waitForBlock.disconnect();
      });
      waitForBlock.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => waitForBlock.disconnect(), 15000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
